import { EnumHelperBase } from '@nfctron/nexus-core';

export interface EnumHelperMethods<
	ExtraData extends object,
	IdValue extends number,
	Name extends string,
	IdKey extends string,
	TExtraDataExtended extends object | undefined,
> {}

export class EnumHelper<
	ExtraData extends object,
	IdValue extends number = number,
	Name extends string = string,
	IdKey extends string = `${Name}Id`,
	TExtraDataExtended extends object | undefined = undefined,
> extends EnumHelperBase<ExtraData, IdValue, Name, IdKey, TExtraDataExtended> {
	/**
	 * Returns base enum value from the given custom enum value
	 * @param value Enum value
	 * @returns Base enum value
	 */
	getBaseFromCustom(value: IdValue): IdValue {
		if (!this.isCustom(value)) return value;
		return Math.floor((value % (1000 * 100)) / 1000) as IdValue;
	}
}
